/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useRef} from 'react';
import {loadModules} from 'esri-loader';
import {LayerSettingsProps} from './LayerSettings';
import TrafficLayerSettings from './TrafficLayerSettings';

export type TrafficLayerContainerProps = LayerSettingsProps & {
  onOpacityChange: Function,
  onToggleExpand?: Function,
  setTrafficSubLayers?: Function,
  opacity: number,
  trafficSubLayers?: string[],
  url: string;
  expandedLayer: string
};

/**
 * @TrafficLayerContainer
 *
 * The Traffic Layer Container provides a component which allows to instantiate
 * the Traffic Layer and Map Layer Setting.
 *
 * ```typescript
 *
 *   <TrafficLayerContainer url={}
 *     isEnabled={}
 *     onToggle={}
 *     onOpacityChange={}
 *     opacity={}
 *     map={} />
 *
 * ```
 */
export const TrafficLayerContainer = ({
  map,
  url,
  layers,
  isEnabled,
  onOpacityChange,
  setTrafficSubLayers,
  opacity,
  trafficSubLayers,
  onToggle,
  onToggleExpand,
  expandedLayer
}: TrafficLayerContainerProps) => {
  const mapImageLayerRef = useRef(null);

  useEffect(() => {
    loadModules(['esri/layers/MapImageLayer']).then(([MapImageLayer]) => {
      mapImageLayerRef.current = MapImageLayer;
    });
  }, []);
    
  if (mapImageLayerRef.current) {
    return (
      <TrafficLayerSettings mapImageLayer={mapImageLayerRef.current}
        isEnabled={isEnabled}
        url={url}
        onToggle={onToggle}
        onToggleExpand={onToggleExpand}
        onOpacityChange={onOpacityChange}
        opacity={opacity}
        setTrafficSubLayers={setTrafficSubLayers}
        trafficSubLayers={trafficSubLayers}
        layers={layers}
        map={map}
        expandedLayer={expandedLayer} />
    );
  }
  return null;
};

export default TrafficLayerContainer;
